import React, { useEffect } from "react";
import "./VarientProductImageSlider.css";
import { MdOutlineExpandLess } from "react-icons/md";
import { IconContext } from "react-icons";

const VarientProductImageSlider = (props) => {
  const {
    varientProductActiveImage,
    selectedVarienImageArray,
    defualtProduct,
  } = props;
  // console.log("selectedVarienImageArray ", selectedVarienImageArray);

  useEffect(() => {}, [selectedVarienImageArray]);

  return (
    <div
      id="carouselExampleControls"
      className="carousel slide"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        {selectedVarienImageArray && selectedVarienImageArray.length > 1 ? (
          selectedVarienImageArray.map((item, index) => {
            return (
              <>
                <div
                  className={
                    index === 0 ? "carousel-item active" : "carousel-item"
                  }
                >
                  <img
                    src={item?.file_url}
                    key={index}
                    alt="not found"
                    id="product-preview"
                  />
                </div>
              </>
            );
          })
        ) : (
          <div className={"carousel-item active"}>
            <img
              src={
                varientProductActiveImage
                  ? varientProductActiveImage
                  : defualtProduct
              }
              //   key={product_default}
              alt="not found"
              id="product-preview"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default VarientProductImageSlider;
